<div class="patient-app-container" *ngIf="inlinePatientAppUrl$ | async as url"
	[class.dialog-resize]="isResizePatientAppDialog$ | async"
	[class.visible-conflict]="isPatientInConflict$ | async">
	<iframe [attr.id]="patientAppId.Inline" class="patient-app-iframe" [src]="url"></iframe>
</div>
